import { BrowserRouter, Route, Routes } from 'react-router-dom';
// import Account from './Account';
import './App.css';
// import Form from './Form';
import './store'
import NavBar from './NavBar';
import Banking from './Banking';
import TodoList from './TodoList';
import ReduxThunk from './redux-thunk/ReduxThunk';
function App() {
  return (
    <>
    <BrowserRouter>
    <NavBar/>
      <Routes>
        <Route path='/' element={<Banking/>}/>
        <Route path='/banking' element={<Banking/>}/>
        <Route path='/todo' element={<TodoList/>}/>
        <Route path='/thunk' element={<ReduxThunk/>}/>
      </Routes>
    </BrowserRouter>
    {/* <div>
     <Form/>
     <Account/>
    </div> */}
    </>

  );
}

export default App;
